import script from "./survey-response.vue?vue&type=script&setup=true&lang=js"
export * from "./survey-response.vue?vue&type=script&setup=true&lang=js"

import "./survey-response.vue?vue&type=style&index=0&id=4a989878&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a989878"]])

export default __exports__